import { Node } from '@react-types/shared';
import { useRef } from 'react';

import { accumulateCollectionKeysByProp } from '../utils';

export function useCollectionKeyAccumulator(nodes: Iterable<Node<unknown>>, targetProp: string, targetValue: any) {
  const accumulator = useRef(accumulateCollectionKeysByProp(targetProp, targetValue));
  return accumulator.current(nodes);
}
